export const pageContext = {
    install: (app: any): void => {
        app.config.globalProperties.$pageContext = window.pageContext;
    },
};
